import React, { useState } from 'react';
import TooltipIcon from '../../images/tooltip-icon.svg';
import CountryField from '../CountryField';
import { Link } from 'gatsby';
import { getGciLabel } from '../Table/columns/investment.js';

const ModalTooltip = () => {
	return (
		<div
			className="
	modal__content
	--without-margins
	--with-paddings
	bg:light-grey
	mt-2
	mb-2
"
		>
			<div className="modal-row-info">
				<h3>Score</h3>
				<div>
					<p className="mb-2">
						The Investment Index (worth 25% of the Global Passport
						Index score) is based on Markets Innovation (weighted at
						50% of the Investment Index score), Gross National
						Income Per Capita, and Personal Income (weighted at 25%
						each).
					</p>
				</div>
			</div>
		</div>
	);
};

export const InvestmentModal = (props) => {
	const {
		country,
		invest_points,
		tax_value,
		gci_pillars_points,
		gni_pc_value,
		iso2c,
	} = props;
	return {
		HeaderComponent: () => <CountryField code={iso2c} />,
		BodyComponent: () => {
			const [isTooltipVisible, setTooltipVisibility] = useState(false);

			return (
				<main
					className="modal__content pt-0"
					id="filter-continent-content"
				>
					<div className="mb-4">
						<div className="modal-row">
							<h2>
								Economy ranking score{' '}
								{!isTooltipVisible && (
									<img
										onClick={() =>
											setTooltipVisibility(true)
										}
										src={TooltipIcon}
									/>
								)}
							</h2>
							<div>{invest_points}</div>
						</div>
						{isTooltipVisible && <ModalTooltip />}
						<div className="modal-row">
							<h2>Markets & Innovation</h2>
							<div>{getGciLabel(gci_pillars_points)}</div>
						</div>
					</div>
					<div>
						<div className="modal-row">
							<h2>GNI per capita</h2>
							<div>${gni_pc_value}</div>
						</div>
						<div className="modal-row">
							<h2>Taxation</h2>
							<div>{tax_value}%</div>
						</div>
					</div>
				</main>
			);
		},
		FooterComponent: () => {
			const countryCode = iso2c?.toLowerCase() || country?.toLowerCase();
			const link = `/countries/${countryCode}`;
			return (
				<Link
					to={link}
					className="modal__btn btn btn__primary"
					aria-label="Close this dialog window"
				>
					Country detail
				</Link>
			);
		},
	};
};
